import { gql } from "@apollo/client";

export const LIST_MANUFACTURERS_FULL = gql`
  query listManufacturersFull {
    listManufacturers {
      id
      firstName
      lastName
      email
      type
      isEnable
      manufacturerObject {
        brand
        isBusinessInfo
        isStripeConnected
        isShopifyConnected
        stripeConnectUrl
        isTreeMaker
        businessForm
      }
    }
  }
`;

export const LIST_MANUFACTURERS_BASIC = gql`
  query listManufacturersBasic {
    listManufacturers {
      id
      brand
      isTreeMaker
    }
  }
`;
